// TravelerActivityTab.tsx
import React, {useEffect, useState} from 'react';
import {ReservationService} from "app/services";
import {useRouteMatch} from "react-router-dom";
import LoadingForm from "../../shared-components/loading-form/LoadingForm";
import TravelerActivityItem from "./TravelerActivityItem";
import {useTranslation} from "react-i18next";

type RouteParams = { id?: string }; // ✅ type the params

const TravelerActivityTab = () => {
  const {params} = useRouteMatch<RouteParams>();
  const [activityState, setActivityState] = useState({
    isLoading: false,
    activities: [] as any[],
    error: ''
  });
  const {t} = useTranslation();

  const columns = [
    `${t("app.main.schedules.updateTravelerFlight.age", "Mosha")}`,
    `${t("app.main.configuration.airlineCompanies.create.input1", "Emri")}`,
    `${t("app.main.configuration.airlineCompanies.create.input2", "Mbiemri")}`,
    `${t("app.main.schedules.addPassenger.passengerBirthday", "Date of birth")}`,
    `${t("app.main.schedules.addPassenger.citizenship", "Shtetësia")}`,
    `${t("app.main.schedules.updateTravelerFlight.gender", "Gjinia")}`,
  ];

  useEffect(() => {
    let mounted = true;
    setActivityState(s => ({...s, isLoading: true, error: ''}));

    const id = params?.id;
    if (!id) {
      setActivityState(s => ({...s, isLoading: false}));
      return () => { mounted = false; };
    }

    // @ts-ignore if your service isn’t typed, but better to type it
    ReservationService.fetchTravelersActivities(id)
      .then((res: any[]) => {
        if (!mounted) return;
        setActivityState({ isLoading: false, activities: res ?? [], error: '' });
      })
      .catch((err: any) => {
        if (!mounted) return;
        const msg =
          err?.response?.data?.message ||
          err?.message ||
          'Unexpected error';
        setActivityState(s => ({ ...s, isLoading: false, error: msg }));
      });

    return () => { mounted = false; };
  }, [params?.id]); // ✅ re-run if the id changes

  if (activityState.isLoading) return <LoadingForm />;

  return (
    <div>
      {activityState.error && (
        <div style={{ color: 'crimson', marginBottom: 8 }}>{activityState.error}</div>
      )}

      {!activityState.error && activityState.activities.length === 0 && (
        <div style={{ opacity: 0.7 }}>
          {t("app.main.schedules.activities.empty", "No activities found")}
        </div>
      )}

      {activityState.activities.map((act: any, idx: number) => (
        <TravelerActivityItem key={act?.id || idx} columns={columns} row={act}/>
      ))}
    </div>
  );
};

export default TravelerActivityTab;
